/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/
export default {

    continent   : 'Continent',
    country     : 'Country',
    province    : 'Province',
    city        : 'City',
    neighborhood: 'Neighborhood',

};
